module.exports = __webpack_public_path__ + "static/media/X@3x.ab2912a1.png";